import { captureException } from '@sentry/react'

export default function downloadFile(
  uri?: string,
  name?: string,
  fileFormat?: string,
  blob?: Blob
) {
  // If blob is provided, use it directly; otherwise fetch from URI
  if (blob) {
    const url = window.URL.createObjectURL(blob)
    const fileName = name?.includes('.')
      ? name
      : `${name || 'download'}.${fileFormat || 'pdf'}`
    const a = document.createElement('a')
    a.href = url
    a.setAttribute('download', fileName)
    document.body.appendChild(a)
    a.click()
    a.remove()
    window.URL.revokeObjectURL(url)
    return
  }

  if (!uri || !name || !fileFormat) return

  fetch(uri)
    .then(response => response.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.setAttribute('download', name.split('.')[0] + '.' + fileFormat)
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    })
    .catch(captureException)
}
